<div class="central mb-4">
    <img class="texture" src="assets/images/png/central-banner-texture.jpg" alt="" aria-hidden="true" loading="lazy" />
    <img class="ellipse" src="assets/images/png/central-banner-ellipse.svg" alt="" aria-hidden="true" loading="lazy" />

    <div class="copy">
        <h2>{{ "banner.central_banner_title" | translate }}</h2>
        <div class="d-flex align-items center justify-content-center justify-content-md-start">
            <p>{{ "banner.central_banner_subtitle" | translate }}</p>
            <img #pop="bs-popover" src="/assets/images/svg-icons/info-icon-yellow.svg" class="img-fluid ms-2 cursor-pointer" alt="Info Icon" loading="eager" [popover]="bonusreward" [adaptivePosition]="false" placement="bottom"
                (onShown)="popOpen()" (onHidden)="popClose()" triggers="mouseenter:null" containerClass="bonusRewardPopover" />
        </div>
    </div>

    <div class="d-flex price-wrapper align-items-center gap-3">
        <span class="big3x" [ngClass]="{ 'is-landing': isLanding }">
            <span class="reel">
                <span #reelTrack class="reel__track">
                    <span #reelSlotTop class="value">{{ initialValue }}</span>
                    <span #reelSlotBottom class="value">{{ initialValue }}</span>
                </span>
            </span><span class="q">?</span>
        </span>
        <!-- <span class="line"></span>
        <span class="list-text">{{ "banner.at_list_price" | translate }}</span> -->
    </div>
</div>
<ng-template #bonusreward>
    <app-bonus-reward (closed)="pop.hide()"></app-bonus-reward>
</ng-template>